/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import dayjs from "dayjs";
import Config from "data/config";

export function getDimensionsText (image) {
    if (!image?.width || !image?.height) {
        return "Unknown";
    }
    return `${image?.width} x ${image.height} px`;
}

export function getFileTypeName (type) {
    switch (type) {
        case "image/png":
            return "PNG Image";
        case "image/jpeg":
            return "JPEG Image";
        default:
            return type;
    }
}

export function formatDate (date) {
    return dayjs(date).format(Config.dates.display.datetime_short);
}
